import React from 'react';
import { Route } from 'react-router-dom';
import { homeRoutePerm } from 'components/Routes/routePermissions';
import PageRoute from '../../components/Routes/PageRoute';
import Home from './Home';

const { userCapabilities } = homeRoutePerm;

export const homeRoutes = (
  <Route
    path="/home"
    element={
      <PageRoute userCapabilities={userCapabilities}>
        <Home />
      </PageRoute>
    }
  />
);
